module.exports = __webpack_public_path__ + "img/income.60c02cef.png";